<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<button @click="$refs.create.open()" class="btn btn-success btn-circle">
					<i class="fa fa-plus" aria-hidden="true"></i>
				</button>
			</div>
		</div>
		<div v-if="lists" class="row">
			<div v-if="lists.length" class="col-md-12">
				<table class="table table-hover table-striped table-condensed">
					<thead>
						<tr>
							<th>
								Ref.
							</th>
							<th>
								Precio
							</th>
							<th>
								Descuento
							</th>
							<th>
								Ahorro
							</th>
							<th>
								Total
							</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="list in lists">
							<td>
								{{ list.ref }}
							</td>
							<td>
								{{ list.price }}
							</td>
							<td>
								{{ list.discount }}
							</td>
							<td>
								{{ list.save }}
							</td>
							<td>
								{{ list.total }}
							</td>
							<td>
								<div class="btn-group">
									<button @click="$refs.edit.open(list)" class="btn btn-info btn-circle">
										<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
									</button>
								</div>
								<div class="btn-group">
									<button @click="destroy(list)" class="btn btn-danger btn-circle">
										<i class="fa fa-trash" aria-hidden="true"></i>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<template v-if="product">
			<create
				@reload="reload"
				ref="create"
				:user="user"
				:isAuth="isAuth"
				:product="product">
			</create>
			<edit
				@reload="reload"
				ref="edit"
				:user="user"
				:isAuth="isAuth"
				:product="product">
			</edit>
		</template>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Create from './../views/Create.vue'
	import Edit from './../views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'product', 'lists'],
		components: {
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				groups: null,
			}
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			destroy (list) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/price/lists/' + list.id)
							.then(response => {
								let index = that.lists.indexOf(list)
								that.lists.splice(index, 1)
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/components/priceList/layout/PriceList.vue